import React from "react";
import { FormattedMessage } from "react-intl";
import { useTheme } from "styled-components";
import { Hemisphere, SeasonType } from "../../domain/orchestrationCriteria.entity";
import {
  criteriaModalMessages as messages,
  useHemisphereLabels,
  useSeasonTypeLabels,
} from "../../../orchestrator.messages";

interface SeasonInputProps {
  seasons: SeasonType[];
  hemisphere: Hemisphere;
  onToggle: (season: SeasonType) => void;
  onHemisphereChange: (hemisphere: Hemisphere) => void;
}

export function SeasonInput({
  seasons,
  hemisphere,
  onToggle,
  onHemisphereChange,
}: SeasonInputProps) {
  const theme = useTheme();
  const seasonTypeLabels = useSeasonTypeLabels();
  const hemisphereLabels = useHemisphereLabels();

  return (
    <div className="space-y-4">
      <div>
        <label className="block font-medium text-gray-700 mb-2">
          <FormattedMessage {...messages.seasons} />
        </label>
        <div className="flex flex-wrap gap-2">
          {Object.values(SeasonType)
            .filter(s => s !== SeasonType.SEASON_TYPE_UNSPECIFIED)
            .map(season => (
              <label
                key={season}
                className={`px-3 py-1 rounded border cursor-pointer text-sm ${
                  seasons.includes(season)
                    ? `bg-[${theme.textColor}] text-white border-[${theme.textColor}]`
                    : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                }`}>
                <input
                  type="checkbox"
                  checked={seasons.includes(season)}
                  onChange={() => onToggle(season)}
                  className="sr-only"
                />
                {seasonTypeLabels[season]}
              </label>
            ))}
        </div>
      </div>

      <div>
        <label className="block font-medium text-gray-700 mb-1">
          <FormattedMessage {...messages.hemisphere} />
        </label>
        <select
          value={hemisphere}
          onChange={e => onHemisphereChange(e.target.value as Hemisphere)}
          className="w-full border rounded px-3 py-2">
          {Object.values(Hemisphere)
            .filter(h => h !== Hemisphere.HEMISPHERE_UNSPECIFIED)
            .map(h => (
              <option key={h} value={h}>
                {hemisphereLabels[h]}
              </option>
            ))}
        </select>
      </div>
    </div>
  );
}
